import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { InsentiveInfo } from "../../../SchemaInfo/info";
import LoadingPage from "../../../Components/layouts/loading";
import { InsentiveEditSchema } from "../../../Schemas/sales/incentive_edit_schema";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import CustomRadioButton from "../../../CustomComponent/custom_radio";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import GSTCalculator from "../../../Components/Functions/preGstCalulator";
import { FcBullish } from "react-icons/fc";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import CallTrackingTable from "../Call Tracking/calltracking.table";
import { useSelector } from "react-redux";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { extractDate } from "../../../Components/Functions/date.fun";
import { BsCheck2Square, BsSlashCircle } from "react-icons/bs";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";

const tableHead = [
  "date",
  "Client Name",
  "Sell Product",
  "Amount (-GST)",
  "incentive",
  "creator",
  "status",
  // "description",
];
const getSell = (pro) => {
  if (pro === "hydroponic masterclass") {
    return "Hydroponic Masterclass";
  }
  if (pro === "practical training") {
    return "Practical Training";
  }
  if (pro === "physical site inspection") {
    return "Physical Site Inspection";
  }
  if (pro === "site inspection kit") {
    return "Site Inspection Kit";
  }
  if (pro === "aif project report") {
    return "AIF Project Report";
  }
  if (pro === "project conversion") {
    return "Project Conversion";
  }
  if (pro === "construction payment") {
    return "Construction Payment";
  }
  if (pro === "allother") {
    return "All other sales excluding CEA and Hydroponics";
  }
};
const EditIncentive = () => {
  const [isDropdown, setIsDropdown] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [insentiveInfo, setInsentiveInfo] = useState(InsentiveInfo);
  const [callsData, setCallsData] = useState([]);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const user = useSelector((store) => store.login.user);

  const { id } = useParams();
  function formatSecondsToHMS(seconds) {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    const pad = (n) => n.toString().padStart(2, "0");
    return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
  }

  useEffect(() => {
    if (
      insentiveInfo?.leadId &&
      (insentiveInfo?.sellsType === "construction payment" ||
        insentiveInfo?.sellsType === "project conversion")
    ) {
      performRequest(
        "GET",
        `/incentive/getIncentiveByLeadId/${insentiveInfo.leadId}`
      )
        .then((res) => {
          if (res.status === 200) {
            setPaymentHistory(res.data);
          } else {
            Toast("error", "Error while getting Incentive Information!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [insentiveInfo]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/incentive/getIncentiveById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setInsentiveInfo(res.data);
        } else {
          Toast("error", "Error while getting Incentive Information!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handelSubmit = (values) => {
    values = {
      ...values,
    };
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    setLoading(true);
    performRequest(
      "PATCH",
      `/incentive/updateIncentive/${id}`,
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Revenue updated successfully!");
          navigate(`/revenue-management/`);
        } else {
          Toast("error", "Error while updating incentive");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const handleInputChange = (e, props) => {
    let { value } = e.target;
    value = value.trim();
    if (value.length < 2) {
      setIsDropdown([]);
      setShow(false);
      setIsSearchLoading(false);
      return;
    }
    setIsSearchLoading(true);
    performRequest(
      "GET",
      `/leads_v2/getallleads/?search=${encodeURIComponent(value)}`
    )
      .then((res) => {
        if (res.status === 200) {
          setIsDropdown(res.data?.leads || []);
          setShow(true);
        } else {
          Toast("error", "Error while fetching leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setIsSearchLoading(false));
  };

  useEffect(() => {
    if (insentiveInfo?.contact_number) {
      performRequest(
        "GET",
        getFilteredURL(`/callTracking/getAllCallTracking`, 1, {
          leadname: insentiveInfo?.contact_number,
        })
      )
        .then((res) => {
          if (res.status === 200) {
            setCallsData(res.data);
            // setTotalPages(Math.ceil(res.data?.CallRecordCount / 50));
          } else {
            Toast("error", "Error while getting data!");
          }
        })
        .catch((err) => CustomErrorResponse(err))
        .finally(() => setLoading(false));
    }
  }, [insentiveInfo]);
  let searchTimer;
  function startSearch(e, props) {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => handleInputChange(e, props), 1000);
  }
  const getPreGSTAmount = (total, gstPercent) => {
    if (!total || !gstPercent) return 0;

    const baseAmount = total / (1 + gstPercent / 100);
    return Number(baseAmount.toFixed(2)); // optional rounding
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcBullish className="fs-2  me-1" /> Revenue Management
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <GSTCalculator />
            <div className="card-header">
              <h2 className="page-title">Edit Sell</h2>
            </div>
            <Formik
              initialValues={insentiveInfo}
              validationSchema={InsentiveEditSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Select lead
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          disabled
                          onChange={(e) => {
                            props.setFieldValue("leadName", e.target.value);
                            startSearch(e, props);
                          }}
                          name="leadName"
                        ></CustomInput>
                        {isSearchLoading ? (
                          <div className="p-1">Loading leads...</div>
                        ) : (
                          show && (
                            <div
                              style={{ maxHeight: "300px", overflow: "scroll" }}
                            >
                              {isDropdown && isDropdown.length > 0 ? (
                                isDropdown.map((lead) => (
                                  <span
                                    key={lead.id}
                                    onClick={() => {
                                      props.setFieldValue(
                                        "leadName",
                                        lead.full_name
                                      );
                                      setIsDropdown([]);
                                      setShow(false);
                                    }}
                                    className="card p-1 cursor-pointer"
                                  >
                                    {lead.full_name}
                                  </span>
                                ))
                              ) : (
                                <span className="p-1">
                                  No lead found with this name
                                </span>
                              )}
                            </div>
                          )
                        )}
                        {props.touched.leadName && props.errors.leadName && (
                          <p className="text-danger">{props.errors.leadName}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Contact number
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="contact_number" disabled />
                        {props.touched.contact_number &&
                          props.errors.contact_number && (
                            <p className="text-danger">
                              {props.errors.contact_number}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Payment Mode
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="paymentMode">
                          <option value="">Select</option>
                          <option value="cash">Cash</option>
                          <option value="cheque">Cheque</option>
                          <option value="upi">UPI</option>
                          <option value="imps">IMPS</option>
                          <option value="rtgs">RTGS</option>
                          <option value="nft">NFT</option>
                        </CustomSelect>

                        {props.touched.paymentMode &&
                          props.errors.paymentMode && (
                            <p className="text-danger">
                              {props.errors.paymentMode}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Payment date
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="paymentDate" type="date" />
                        {props.touched.paymentDate &&
                          props.errors.paymentDate && (
                            <p className="text-danger">
                              {props.errors.paymentDate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Select Sells
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="sellsType">
                          <option value="">Select</option>
                          {/* <option value="hydroponic masterclass">
                            Hydroponic Masterclass
                          </option> */}
                          <option value="practical training">
                            Practical Training
                          </option>
                          <option value="physical site inspection">
                            Physical Site Inspection
                          </option>
                          <option value="site inspection kit">
                            Site Inspection Kit
                          </option>
                          <option value="aif project report">
                            AIF Project Report
                          </option>
                          <option value="project conversion">
                            Project Conversion
                          </option>
                          <option value="construction payment">
                            Construction Payment
                          </option>
                          <option value="allother">
                            All other sales excluding CEA and Hydroponics
                          </option>
                        </CustomSelect>
                        {props.touched.sellsType && props.errors.sellsType && (
                          <p className="text-danger">
                            {props.errors.sellsType}
                          </p>
                        )}
                      </div>
                    </div>

                    {props.values.sellsType === "physical site inspection" && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 required">
                          Recived SI Amount
                        </label>
                        <div className="w-100 col">
                          <CustomInput
                            name="actualSIAmount"
                            onChange={(e) => {
                              let amt = e.target.value;
                              let preGst = getPreGSTAmount(amt, 18);
                              if (
                                preGst > 10000 &&
                                props.values.sellsType ===
                                  "physical site inspection"
                              ) {
                                preGst = 10000;
                              }
                              props.setFieldValue("preGstAmount", preGst);
                              props.setFieldValue("actualSIAmount", amt);

                              props.setFieldValue(
                                "incentiveAmount",
                                preGst * 0.0025
                              );
                            }}
                          />
                          {props.touched.actualSIAmount &&
                            props.errors.actualSIAmount && (
                              <p className="text-danger">
                                {props.errors.actualSIAmount}
                              </p>
                            )}
                          <p className="text-muted">
                            Amount mentioned here should be reflected in KBPL
                            bank account.
                          </p>
                        </div>
                      </div>
                    )}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Pre GST amount
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="preGstAmount"
                          onChange={(e) => {
                            let preGst = e.target.value;

                            if (
                              preGst > 10000 &&
                              props.values.sellsType ===
                                "physical site inspection"
                            ) {
                              preGst = 10000;
                            }
                            props.setFieldValue("preGstAmount", preGst);

                            props.setFieldValue(
                              "incentiveAmount",
                              preGst * 0.0025
                            );
                          }}
                        />
                        {props.touched.preGstAmount &&
                          props.errors.preGstAmount && (
                            <p className="text-danger">
                              {props.errors.preGstAmount}
                            </p>
                          )}
                        <p className="text-muted">
                          Amount mentioned here should be reflected in KBPL bank
                          account.
                        </p>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Upload Payment Receipt
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="paymentReceipt"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "paymentReceipt",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.paymentReceipt &&
                          props.errors.paymentReceipt && (
                            <p className="text-danger">
                              {props.errors.paymentReceipt}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Payment Receipt
                      </label>
                      <div className="w-100 col">
                        {insentiveInfo?.paymentReceipt ? (
                          <LazyImageComponent
                            width="70%"
                            src={insentiveInfo.paymentReceipt}
                            alt="Payment Receipt Not Available"
                          />
                        ) : (
                          "Payment Receipt Not Available"
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Revenue Status
                      </label>
                      <div className="w-100 col">
                        <div>
                          <label className="form-check form-check-inline">
                            <CustomRadioButton
                              name="revenueApproved"
                              value="Approved"
                              checked={
                                props.values.revenueApproved === "Approved"
                              }
                            />
                            <span className="form-check-label">Approved</span>
                          </label>
                          <label className="form-check form-check-inline">
                            <CustomRadioButton
                              name="revenueApproved"
                              value="Pending"
                              checked={
                                props.values.revenueApproved === "Pending"
                              }
                            />
                            <span className="form-check-label">Pending</span>
                          </label>
                          <label className="form-check form-check-inline">
                            <CustomRadioButton
                              name="revenueApproved"
                              value="Denied"
                              checked={
                                props.values.revenueApproved === "Denied"
                              }
                            />
                            <span className="form-check-label">Denied</span>
                          </label>
                        </div>
                        {props.touched.revenueApproved &&
                          props.errors.revenueApproved && (
                            <p className="text-danger">
                              {props.errors.revenueApproved}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Sell description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea name="incentiveDescription" rows={5} />
                        {props.touched.incentiveDescription &&
                          props.errors.incentiveDescription && (
                            <p className="text-danger">
                              {props.errors.incentiveDescription}
                            </p>
                          )}
                      </div>
                    </div>
                    {paymentHistory?.length > 0 && (
                      <>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Payment history
                          </label>
                          <div className="table-responsive col">
                            <table className="table table-vcenter">
                              <thead>
                                <tr>
                                  {tableHead?.map((item, index) => {
                                    return <th key={index}>{item}</th>;
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {paymentHistory?.map((item, index) => {
                                  return (
                                    <tr key={item?.id}>
                                      <td>
                                        {extractDate(item?.createdAt) || "N/A"}
                                      </td>
                                      <td style={{ maxWidth: "150px" }}>
                                        {item?.leadName || "N/A"}
                                      </td>
                                      <td style={{ maxWidth: "200px" }}>
                                        {item?.sellsType
                                          ? getSell(item?.sellsType)
                                          : "N/A"}
                                      </td>
                                      <td>
                                        {item?.preGstAmount
                                          ? Math.round(item?.preGstAmount)
                                          : "N/A"}
                                      </td>
                                      <td>
                                        {roundOffCost(
                                          item?.preGstAmount * 0.0025
                                        )}
                                      </td>
                                      <td>{item?.generatedBy || "N/A"}</td>

                                      <td>{item?.revenueApproved}</td>

                                      {/* <td>
                  { item?.generatedById == user?.UserId ?<button
                      disabled={item?.revenueApproved === "Approved"}
                      className="btn btn-sm px-3 btn-danger"
                      onClick={() => goToDelete(item.id)}
                    >
                      Delete
                    </button>:"N/A"}
                  </td> */}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {(user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                          user.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              Full Payment Received ⭐
                            </label>
                            <div className="w-100 col">
                              <CustomCheckbox
                                name="finalPayment"
                                type="checkbox"
                                width={"18px"}
                                height={"18px"}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    props.setFieldValue("finalPayment", true);
                                  } else {
                                    props.setFieldValue("finalPayment", false);
                                  }
                                }}
                              />
                            </div>
                            {props.touched.finalPayment &&
                              props.errors.finalPayment && (
                                <p className="text-danger col-12">
                                  {props.errors.finalPayment}
                                </p>
                              )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <SimpleButton
                        onClick={() =>
                          navigate(`/revenue-management/payment-receipt/${id}`)
                        }
                        disabled={insentiveInfo?.revenueApproved !== "Approved"}
                        buttonText="Generate Receipt"
                        type="primary"
                      />
                      <FormSubmitButton
                        buttonText="Save Sell"
                        disabled={insentiveInfo?.revenueApproved === "Approved"}
                      />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
            {(user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
              user.Role === process.env.REACT_APP_ROLE_ADMIN) && (
              <div className="row">
                {/* FILTER SECTION */}
                <div className="col-md-3">
                  <div className="card p-3">
                    {/* STATS */}
                    <p className="fw-bold fs-2">
                      Total Calls : {callsData?.CallRecordCount}
                    </p>
                    <p className="fw-bold fs-2">
                      Attempted : {callsData?.attemptedCount}
                    </p>
                    <p className="fw-bold fs-2">
                      Incoming : {callsData?.inboundCount}
                    </p>
                    <p className="fw-bold fs-2">
                      Outgoing : {callsData?.outboundCount}
                    </p>
                    <p className="fw-bold fs-2">
                      Answered : {callsData?.answeredCount}
                    </p>
                    <p className="fw-bold fs-2">
                      Unanswered : {callsData?.unAnsweredCount}
                    </p>
                    <p className="fw-bold fs-2">
                      Duration : {formatSecondsToHMS(callsData?.totalDuration)}
                    </p>
                  </div>
                </div>{" "}
                <div className="col-md-9">
                  <div className="card p-3">
                    {callsData && (
                      <>
                        <h3 className="mx-2  mb-2">
                          Sell added by: {insentiveInfo?.generatedBy}
                        </h3>
                        <h3 className="mx-2  mb-2">
                          Lead Owner : {insentiveInfo?.lead_owner}
                        </h3>
                        <h3 className="mx-2 mb-2">
                          Call Records for lead: {insentiveInfo?.leadName}
                        </h3>
                        <CallTrackingTable callsData={callsData?.CallRecord} />
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default EditIncentive;
